<div
  *ngIf="
    spinner &&
    (requestType === requestTypeEnum.dotArr ||
      requestType === requestTypeEnum.campaigns ||
      requestType === requestTypeEnum.leasing ||
      requestType === requestTypeEnum.vo)
  "
  class="loading-overlay"
>
  <div class="spinner-border text-light" role="status"></div>
</div>

<div
  *ngIf="requestType === requestTypeEnum.vo && bookedVehicles.length > 0"
  class="table-container"
>
  <h4 class="text-black fw-bold" class="title-bookings">
    {{ 'myBookings' | i18next }}
  </h4>

  <div class="desktop-only">
    <table class="custom-table">
      <thead>
        <tr>
          <th>{{ 'model' | i18next }}</th>
          <th>{{ 'plateNumber' | i18next }}</th>
          <th>{{ 'color' | i18next }}</th>
          <th>{{ 'combustible' | i18next }}</th>
          <th>{{ 'VNPrice' | i18next }}</th>
          <th>{{ 'VOPrice' | i18next }}</th>
          <th>{{ 'bookings' | i18next }}</th>
          <th class="text-center">
            {{ 'requestListActions' | i18next }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let vehicle of bookedVehicles">
          <td>
            {{
              vehicle.modelName + ' ' + vehicle.engine + ' ' + vehicle.finish
            }}
          </td>
          <td>{{ vehicle.plateNumber }}</td>
          <td>{{ vehicle.exteriorColor }}</td>
          <td>{{ vehicle.fuelType }}</td>
          <td>
            {{
              vehicle.vehicleGroups[0].prices.priceVN
                | number: '1.0-0' : 'es-ES'
            }}€
          </td>
          <td>
            {{
              vehicle.vehicleGroups[0].prices.priceVO
                | number: '1.0-0' : 'es-ES'
            }}€
          </td>
          <td>{{ vehicle.vehicleGroups[0].bookingsVo }}</td>

          <td class="text-center">
            <div class="table-actions">
              <button
                class="btn confirmBlack"
                (click)="openCancelModalBook(vehicle.requestNumber)"
              >
                {{ 'btnDeleteBook' | i18next }}
              </button>
              <button
                class="main--btnContainer__btn btn cancel"
                (click)="openCarDetail(vehicle, true)"
              >
                {{ 'btnSeeDetail' | i18next }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mobile-only">
    <app-car-card
      [spinner]="spinner"
      [stock]="bookedVehicles"
      [requestType]="requestType"
      [isBookedList]="true"
      [viewMobile]="true"
      (onBack)="back()"
      (cancelBooking)="openCancelModalBook($event)"
    >
    </app-car-card>
  </div>
  <div style="height: 20px"></div>
</div>

<h4
  class="text-black fw-bold"
  class="title-bookings"
  *ngIf="requestType === requestTypeEnum.vo"
>
  {{ 'searchVO' | i18next }}
</h4>
<div *ngIf="requestType === requestTypeEnum.vo" class="vo-filters-material">
  <form [formGroup]="form" class="filters-row-material">
    <div class="top-filters-row">
      <mat-form-field class="filter-field">
        <mat-label>{{ 'model' | i18next }}</mat-label>
        <mat-select formControlName="filterModel">
          <mat-option value="">{{ 'all' | i18next }}</mat-option>
          <mat-option *ngFor="let model of models" [value]="model">{{
            model
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>{{ 'finishes' | i18next }}</mat-label>
        <mat-select formControlName="filterFinish">
          <mat-option value="">{{ 'all' | i18next }}</mat-option>
          <mat-option *ngFor="let finish of finishes" [value]="finish">{{
            finish
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>{{ 'combustible' | i18next }}</mat-label>
        <mat-select formControlName="filterFuel">
          <mat-option value="">{{ 'all' | i18next }}</mat-option>
          <mat-option *ngFor="let fuel of fuels" [value]="fuel">{{
            fuel
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="actions-wrapper">
        <button type="button" class="btn" (click)="searchVehicles()">
          {{ 'btnSearch' | i18next | uppercase }}
        </button>
        <span class="download-tooltip-wrapper">
          <button
            type="button"
            class="btn confirmBlack"
            (click)="downloadExcel()"
            [disabled]="
              spinner ||
              (requestType === requestTypeEnum.vo
                ? displayedVehicles.length === 0
                : vehicles?.length === 0)
            "
          >
            <mat-icon>file_download</mat-icon>
          </button>
          <span class="download-tooltip-text">{{
            'downloadExcel' | i18next
          }}</span>
        </span>
        <mat-button-toggle-group
          *ngIf="!isMobile"
          [value]="viewMode"
          (change)="changeViewMode($event.value)"
          class="view-toggle-mat"
        >
          <mat-button-toggle value="cards"
            ><mat-icon>grid_view</mat-icon></mat-button-toggle
          >
          <mat-button-toggle value="table"
            ><mat-icon>view_list</mat-icon></mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>
    </div>

    <div class="price-range-row">
      <div class="price-header">
        <span>{{ 'priceRange' | i18next }}</span>
        <span class="price-display">
          {{ form.get('priceMin')?.value | numberData }}€ -
          {{ form.get('priceMax')?.value | numberData }}€
        </span>
      </div>

      <mat-slider [min]="minPrice" [max]="maxPrice" step="1">
        <input matSliderStartThumb formControlName="priceMin" />
        <input matSliderEndThumb formControlName="priceMax" />
      </mat-slider>

      <div class="price-footer">
        <span>{{ minPrice | numberData }}€</span>
        <span>{{ maxPrice | numberData }}€</span>
      </div>
    </div>
  </form>
</div>

<ng-container
  *ngIf="
    requestType === requestTypeEnum.dotArr ||
    requestType === requestTypeEnum.campaigns ||
    requestType === requestTypeEnum.leasing ||
    requestType === requestTypeEnum.vo
  "
>
  <div
    class="scroll-container"
    (scroll)="requestType === requestTypeEnum.vo ? onScroll($event) : null"
    [style.max-height]="requestType === requestTypeEnum.vo ? '80vh' : 'auto'"
    [style.overflow-y]="requestType === requestTypeEnum.vo ? 'auto' : 'visible'"
  >
    <app-car-card
      *ngIf="viewMode === 'cards'"
      [spinner]="spinner"
      [stock]="
        requestType === requestTypeEnum.vo ? displayedVehicles : vehicles
      "
      [requestType]="requestType"
      [campaignType]="campaignType"
      [isBookedList]="false"
      (requestCar)="vehicleReplacement($event)"
      (carListChange)="handleCarListChange($event)"
      (onBack)="back()"
    >
    </app-car-card>

    <div
      class="table-container"
      *ngIf="
        viewMode === 'table' && !isMobile && requestType === requestTypeEnum.vo
      "
    >
      <div class="text-center p-5" *ngIf="spinner">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <h6
        *ngIf="!spinner && noStock"
        class="text-black fw-bold"
        [style]="'margin-top:40px; margin-bottom:20px'"
      >
        {{ 'noStock' | i18next }}
      </h6>

      <table
        class="custom-table"
        *ngIf="!spinner && displayedVehicles && displayedVehicles.length > 0"
      >
        <thead>
          <tr>
            <th (click)="sort('model')" class="sortable">
              {{ 'model' | i18next }}
              <mat-icon *ngIf="sortColumn === 'model'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('plate')" class="sortable">
              {{ 'plateNumber' | i18next }}
              <mat-icon *ngIf="sortColumn === 'plate'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('plateRegistrationDate')" class="sortable">
              {{ 'summaryVinNumberDate' | i18next }}
              <mat-icon *ngIf="sortColumn === 'plateRegistrationDate'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('kms')" class="sortable">
              {{ 'kms' | i18next }}
              <mat-icon *ngIf="sortColumn === 'kms'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('color')" class="sortable">
              {{ 'color' | i18next }}
              <mat-icon *ngIf="sortColumn === 'color'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('VNPrice')" class="sortable">
              {{ 'VNPrice' | i18next }}
              <mat-icon *ngIf="sortColumn === 'VNPrice'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('VOPrice')" class="sortable">
              {{ 'VOPrice' | i18next }}
              <mat-icon *ngIf="sortColumn === 'VOPrice'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th (click)="sort('bookings')" class="sortable">
              {{ 'bookings' | i18next }}
              <mat-icon *ngIf="sortColumn === 'bookings'">{{
                sortDirection === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'
              }}</mat-icon>
            </th>
            <th class="text-center">{{ 'requestListActions' | i18next }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vehicle of displayedVehicles">
            <td>
              {{
                vehicle.modelName + ' ' + vehicle.engine + ' ' + vehicle.finish
              }}
            </td>
            <td>{{ vehicle.plateNumber }}</td>
            <td>{{ vehicle.plateRegistrationDate | date: 'dd/MM/yyyy' }}</td>
            <td>
              {{ vehicle.vehicleGroups[0].kms | number: '1.0-0' : 'es-ES' }}
            </td>
            <td>{{ vehicle.exteriorColor }}</td>
            <td>
              {{
                vehicle.vehicleGroups[0].prices.priceVN
                  | number: '1.0-0' : 'es-ES'
              }}€
            </td>
            <td>
              {{
                vehicle.vehicleGroups[0].prices.priceVO
                  | number: '1.0-0' : 'es-ES'
              }}€
            </td>
            <td>{{ vehicle.vehicleGroups[0].bookingsVo }}</td>

            <td class="text-center">
              <div class="table-actions">
                <button
                  class="btn confirmBlack"
                  (click)="vehicleReplacement(vehicle)"
                >
                  {{ 'reserve' | i18next }}
                </button>
                <button
                  class="main--btnContainer__btn btn cancel"
                  (click)="openCarDetail(vehicle, false)"
                >
                  {{ 'btnSeeDetail' | i18next }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<div *ngIf="requestType === requestTypeEnum.vo" class="vo-info-texts">
  <p class="vo-info-text">
    {{ 'infoTextVO' | i18next }}
  </p>

  <p class="vo-info-text">
    {{ 'infoPriceVO' | i18next }}
  </p>

  <p class="vo-info-text">
    {{ 'infoPriceVN' | i18next }}
  </p>
</div>

<div style="height: 20px"></div>
<div
  class="d-flex justify-content-between"
  *ngIf="requestType === requestTypeEnum.vo"
>
  <button
    class="btnContainer__btn btnContainer__btn__back"
    [style]="
      'background-color: #2c2a29; display: flex; align-items: center; gap: 0.5rem'
    "
    mat-button
    (click)="back()"
  >
    <mat-icon class="icon">arrow_back</mat-icon>
    {{ 'btnReturn' | i18next | uppercase }}
  </button>
</div>

<section
  *ngIf="
    requestType !== requestTypeEnum.dotArr &&
    requestType !== requestTypeEnum.campaigns &&
    requestType !== requestTypeEnum.leasing &&
    requestType !== requestTypeEnum.vo
  "
  class="stock"
>
  <h5 class="stock--title">{{ 'chooseModel' | i18next }}</h5>
  <form class="stock--form" [formGroup]="form">
    <ul class="stock--form__list" [hidden]="spinner">
      <p *ngIf="noStock || vehicles?.length === 0">{{ 'noStock' | i18next }}</p>
      <li class="stock--form__list--listItem" *ngFor="let vehicle of vehicles">
        <mat-radio-group formControlName="selectedVehicle" color="primary">
          <mat-radio-button
            class="stock--form__list--btn"
            id="{{ vehicle.VIN }}"
            [value]="vehicle.VIN"
            (change)="vehicleReplacement(vehicle)"
          >
            {{ vehicle.model }} {{ vehicle.plateNumber }}
            {{ vehicle.exteriorColorDescription }}
          </mat-radio-button>
        </mat-radio-group>
      </li>
    </ul>
  </form>

  <div class="text-center spinner-container" *ngIf="spinner">
    <div class="spinner-border spinner" role="status"></div>
  </div>

  <section class="stock--selectedVehicle" *ngIf="selectedVehicle">
    <h6 class="stock--selectedVehicle__title">
      {{ 'selectedVehicleConfig' | i18next }}
    </h6>
    <div class="stock--selectedVehicle__infoContainer">
      <div class="stock--selectedVehicle__infoContainer--row">
        <p class="label lrow">{{ 'color' | i18next }}</p>
        <p class="text">{{ selectedVehicle.exteriorColorDescription }}</p>
      </div>
      <div class="stock--selectedVehicle__infoContainer--row">
        <p class="label lrow">{{ 'requestPccTMAIMG' | i18next }}</p>
        <p class="text">{{ selectedVehicle.tmaimg }}</p>
      </div>
      <div class="stock--selectedVehicle__infoContainer--row">
        <p class="label lrow">{{ 'model' | i18next }}</p>
        <p class="text">{{ selectedVehicle.model }}</p>
      </div>
      <div class="stock--selectedVehicle__infoContainer--row">
        <p class="label lrow">{{ 'requestPccEmissions' | i18next }}</p>
        <p class="text">{{ selectedVehicle.emissions }}</p>
      </div>

      <div class="stock--selectedVehicle__infoContainer--row">
        <p class="label lrow">{{ 'vinNumber' | i18next }}</p>
        <p class="text">{{ selectedVehicle.VIN }}</p>
      </div>
      <div class="stock--selectedVehicle__infoContainer--lastRow">
        <div class="item">
          <p class="label">{{ 'combustible' | i18next }}</p>
          <p class="text">{{ selectedVehicle.fuelType }}</p>
        </div>
        <div
          class="item mg-l"
          *ngIf="requestType !== requestTypeEnum.generalServices"
        >
          <p class="label">{{ 'requestFee' | i18next }}</p>
          <p class="cuota">
            {{
              !!selectedVehicle.prices?.fee && selectedVehicle.prices.fee >= 0
                ? selectedVehicle.prices.fee + '€'
                : noData
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="stock--selectedVehicle__infoContainer--grid">
      <p class="label">{{ 'requestPccDescription' | i18next }}</p>
      <p class="text">{{ getFormattedDescriptions() }}</p>
    </div>

    <div class="extra-info" *ngIf="!carPoolCenterDate">
      <div class="stock--selectedVehicle__infoContainer--grid">
        <p class="label">{{ 'requestPccNote' | i18next }}</p>
        <p class="text">
          {{ 'requestPccNoteText1' | i18next }}
          {{ 'requestPccNoteText2' | i18next }}
        </p>
      </div>
      <div class="stock--selectedVehicle__infoContainer--grid">
        <p class="label">{{ 'requestPccPenalty' | i18next }}</p>
        <div class="text">
          <span class="bold">{{ 'requestPccPenaltyInc1' | i18next }}</span>
          {{ 'requestPccPenaltyInc1Num' | i18next }}
          <span class="bold">{{ 'requestPccPenaltyInc2' | i18next }}</span>
          {{ 'requestPccPenaltyInc2Num' | i18next }}
          <div>{{ 'requestPccPenaltyDesc' | i18next }}</div>
        </div>
      </div>
      <p class="extra-info">{{ 'requestPccEndNote' | i18next }}</p>
    </div>
  </section>
</section>
